import { render, staticRenderFns } from "./CKKanban.vue?vue&type=template&id=418472a8&scoped=true"
import script from "./CKKanban.vue?vue&type=script&lang=js"
export * from "./CKKanban.vue?vue&type=script&lang=js"
import style0 from "./CKKanban.vue?vue&type=style&index=0&id=418472a8&prod&lang=css"
import style1 from "./CKKanban.vue?vue&type=style&index=1&id=418472a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418472a8",
  null
  
)

export default component.exports